import types from './types';
import { ThunkDispatch } from "redux-thunk";
import api from 'constants/api';
import _get from "lodash/get";

export const printMembersReport = (search: any) => (dispatch: ThunkDispatch<any, any, any>) => {

  dispatch({ type: types.GET_MEMBER_REPORT_PRINT_FILE_REQUEST });

  return api.app.memberReport.printMembersReport(search)
    .then((res: any) => {

      dispatch({
        type: types.GET_MEMBER_REPORT_PRINT_FILE_SUCCESS,
        payload: res,
      });

      return res;
    })
    .catch((err: Error) => {
      const msg = _get(err, 'response.data.msg', 'Get failed!');
      const errors = _get(err, 'response.data.errors', {});
      const payload = { ...err, msg, errors };

      dispatch({
        type: types.GET_MEMBER_REPORT_PRINT_FILE_FAILURE,
        payload,
      });

      return Promise.reject(payload);
    });
};
  
export const downloadMemberFile = (search: any) => (dispatch: ThunkDispatch<any, any, any>) => {

  dispatch({ type: types.GET_MEMBER_REPORT_EXCEL_FILE_REQUEST });

  return api.app.memberReport.downloadMemberFile(search)
    .then((res: any) => {

      dispatch({
        type: types.GET_MEMBER_REPORT_EXCEL_FILE_SUCCESS,
        payload: res,
      });

      return res;
    })
    .catch((err: Error) => {
      const msg = _get(err, 'response.data.msg', 'Get failed!');
      const errors = _get(err, 'response.data.errors', {});
      const payload = { ...err, msg, errors };

      dispatch({
        type: types.GET_MEMBER_REPORT_EXCEL_FILE_FAILURE,
        payload,
      });

      return Promise.reject(payload);
    });
};
  
